import {
    widgetsByIdSelector
} from '../../dashboard/selectors/widget-selectors';
import {
    fetchAggResultsByCanvasId
} from '../../common/actions/aggregate-results-action-creators';

export function initializeMySendersWidget( widgetId ){
    return ( dispatch, getState ) => {
        const canvasId = widgetsByIdSelector( getState() )[widgetId].canvasId;

        return dispatch( fetchAggResultsByCanvasId( canvasId ) );
    };
}
